import { MicrositeTemplate } from '~/model';
import { useRegisterSection } from '~/hooks/useSections';
import VideoBlockAlpha from '~/editor/templates/alpha/VideoBlockAlpha';
import VideoBlockDelta from '~/editor/templates/delta/VideoBlockDelta';
import VideoBlockEpsilon from '~/editor/templates/epsilon/VideoBlockEpsilon';
import VideoBlockEta from '~/editor/templates/eta/VideoBlockEta';
import VideoBlockZeta from '~/editor/templates/zeta/VideoBlockZeta';
import { type ComponentConfig } from '@puckeditor/core';
import { DEMO_SLIDESHOW_1, DEMO_SLIDESHOW_2 } from '~/demo';
import useIsTab from '~/hooks/useIsTab';
import MicrositeVideo from '~/components/MicrositeVideo';
import MicrositeRatio from '~/components/MicrositeRatio';
import VideoBlockBeta from '~/editor/templates/beta/VideoBlockBeta';
import type { VideoBlockVariant } from '~/editor/blocks/video/common';

export interface VideoBlockProps {
	navigation?: boolean;
	title?: string;
	template: MicrositeTemplate;
}

export const PUCK_BLOCK_VIDEO: ComponentConfig<VideoBlockProps> = {
	label: 'Videos',
	fields: {
		title: {
			type: 'text',
		},
		navigation: {
			type: 'radio',
			options: [
				{ label: 'On', value: true },
				{ label: 'Off', value: false },
			],
		},
		template: {
			type: 'radio',
			options: [
				{ label: 'Alpha', value: MicrositeTemplate.ALPHA },
				{ label: 'Beta', value: MicrositeTemplate.BETA },
				{ label: 'Delta', value: MicrositeTemplate.DELTA },
				{ label: 'Epsilon', value: MicrositeTemplate.EPSILON },
				{ label: 'Eta', value: MicrositeTemplate.ETA },
				{ label: 'Zeta', value: MicrositeTemplate.ZETA },
			],
		},
	},
	defaultProps: {
		navigation: true,
		title: 'Video',
		template: MicrositeTemplate.ETA,
	},
	permissions: {
		duplicate: false,
	},
	render(props) {
		return <VideoBlock {...props} />;
	},
};

export default function VideoBlock({ navigation = true, title, template }: VideoBlockProps) {
	const id = useRegisterSection('video', title ?? 'Video', navigation);
	const isTab = useIsTab();
	const videos = [DEMO_SLIDESHOW_1];

	if (isTab) {
		return (
			<MicrositeRatio id={id}>
				<MicrositeVideo video={videos[0]} />
			</MicrositeRatio>
		);
	}

	const props: VideoBlockVariant = {
		id,
		title,
		videos: [DEMO_SLIDESHOW_1, DEMO_SLIDESHOW_2],
	};

	if (template === MicrositeTemplate.ALPHA) {
		return <VideoBlockAlpha title="Video" video={DEMO_SLIDESHOW_1} />;
	}
	if (template === MicrositeTemplate.BETA) {
		return <VideoBlockBeta {...props} />;
	}
	if (template === MicrositeTemplate.DELTA) {
		return <VideoBlockDelta title="Video" video={DEMO_SLIDESHOW_1} />;
	}
	if (template === MicrositeTemplate.EPSILON) {
		return <VideoBlockEpsilon title="Video" video={DEMO_SLIDESHOW_1} />;
	}
	if (template === MicrositeTemplate.ETA) {
		return <VideoBlockEta title="Video" video={DEMO_SLIDESHOW_1} />;
	}
	if (template === MicrositeTemplate.ZETA) {
		return <VideoBlockZeta title="Video" video={DEMO_SLIDESHOW_1} />;
	}
}
